/**
 * 商城Vuex-actions
 */
export default {
    saveUserName(context, username) {
        context.commit('saveUserName', username);
    },
    saveCartCount(context, count) {
        context.commit('saveCartCount', count);
    },
    catId(context, catId) {
        context.commit('catId', catId);
    },
    catParentId(context, pid) {
        context.commit('catParentId', pid);
    },
    saveUseInfo(context, data) {
        context.commit('useInfo', data);
    },
    saveSetting(context, data) {
        context.commit('setting', data);
    },
    saveCatList(context, data) {
        context.commit('cat_list', data);
    },
    saveHomeInfo(context, data) {
        context.commit('home_info', data);
    }
}
